import React from "react";
import Lottie from 'react-lottie-player';
import { withStyles, withTheme } from "@material-ui/core/styles";
import { compose } from "recompose";

const styles = () => ({
  container:{
    display: "flex",
    justifyContent:"center"
  }
})
const DynamicRoutingAnimation = props => {
  return (
    <div className={`${props.classes.container} ${props.theme.themeName}`}>
       <Lottie
        loop
        play
        animationData={props.animationJSON}
        style={{ width: props.dimension, height: props.dimension }}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />
    </div>
  );
};
export default compose(withStyles(styles), withTheme())(DynamicRoutingAnimation);
